import { render, staticRenderFns } from "./UnitSelector.vue?vue&type=template&id=b682e3ae&"
import script from "./UnitSelector.vue?vue&type=script&lang=js&"
export * from "./UnitSelector.vue?vue&type=script&lang=js&"
import style0 from "./UnitSelector.vue?vue&type=style&index=0&id=b682e3ae&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports